import React, { useMemo, useState } from "react";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import RenewalMTAQuoteCreationModal from "@/components/organisms/renewal-mta-consent-popup/renewal-mta-consent-popup";
import { useRenewalStateContext } from "@/providers/renewal-state-provider";

type BookTravellingBeforeProps = {
  travelingBefore: string;
  editCtaLabel: string;
  isTravellingBeforeRenewal: boolean | null;
};

function BookTravellingBefore({
  editCtaLabel,
  travelingBefore,
  isTravellingBeforeRenewal,
}: Readonly<BookTravellingBeforeProps>) {
  const { updateLastEditAccordion } = useRenewalStateContext();
  const [getUserTravelingConcent, setGetUserTravelingConcent] = useState(false);

  const handleMTAModalClose = () => {
    setGetUserTravelingConcent(false);
  };

  const travelerConcentModal = useMemo(() => {
    return (
      <RenewalMTAQuoteCreationModal
        isOpen={getUserTravelingConcent}
        handleClose={handleMTAModalClose}
      />
    );
  }, [getUserTravelingConcent]);

  return (
    <div>
      <p className="font-body-font w-[214px] md:w-auto text-2xs font-[400] leading-[24px] text-text-functional-subtle">
        {travelingBefore}
      </p>
      <div className="flex justify-between items-start">
        <div>
          <p className="font-body-font text-xs font-[700] leading-[27px] text-interactive-secondary-default">
            {isTravellingBeforeRenewal ? "Yes" : "No"}
          </p>
        </div>
        <div className="h-[18px]">
          <LabelButtonWrapper
            label={editCtaLabel}
            hierarchy="tertiary"
            className="font-body-font leading-[18px] font-[600] text-xs py-spacing-xxs realtive top-[-2px] !px-spacing-xxs ml-spacing-m"
            onClick={() => {
              setGetUserTravelingConcent(true);
              updateLastEditAccordion("medical-conditions");
            }}
          />
        </div>
      </div>
      {travelerConcentModal}
    </div>
  );
}

export default BookTravellingBefore;
